enum QuizEventStatuses {
  Pending = 'pending',
  Triggered = 'triggered',
  TriggeringFailed = 'triggeringFailed'
}

export default QuizEventStatuses;
